// extracted by mini-css-extract-plugin
export var banner = "_fn-0";
export var closeButton = "_fn-2";
export var greenCheckmark = "_fn-3";
export var hereLink = "_fn-4";
export var titleIcon = "_fn-1";